"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfNumberingFormats = void 0;
var list_level_properties_1 = require("../../core/model/numbering-lists/list-level-properties");
exports.RtfNumberingFormats = [
    list_level_properties_1.NumberingFormat.Decimal,
    list_level_properties_1.NumberingFormat.UpperRoman,
    list_level_properties_1.NumberingFormat.LowerRoman,
    list_level_properties_1.NumberingFormat.UpperLetter,
    list_level_properties_1.NumberingFormat.LowerLetter,
    list_level_properties_1.NumberingFormat.Ordinal,
    list_level_properties_1.NumberingFormat.CardinalText,
    list_level_properties_1.NumberingFormat.OrdinalText,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.AIUEOHiragana,
    list_level_properties_1.NumberingFormat.Iroha,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.DecimalEnclosedCircle,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.AIUEOFullWidthHiragana,
    list_level_properties_1.NumberingFormat.IrohaFullWidth,
    list_level_properties_1.NumberingFormat.DecimalZero,
    list_level_properties_1.NumberingFormat.Bullet,
    list_level_properties_1.NumberingFormat.Ganada,
    list_level_properties_1.NumberingFormat.Chosung,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.KoreanCounting,
    list_level_properties_1.NumberingFormat.KoreanDigital,
    list_level_properties_1.NumberingFormat.KoreanDigital2,
    list_level_properties_1.NumberingFormat.KoreanLegal,
    list_level_properties_1.NumberingFormat.Hebrew1,
    list_level_properties_1.NumberingFormat.ArabicAlpha,
    list_level_properties_1.NumberingFormat.Hebrew2,
    list_level_properties_1.NumberingFormat.ArabicAbjad,
    list_level_properties_1.NumberingFormat.HindiVowels,
    list_level_properties_1.NumberingFormat.HindiConsonants,
    list_level_properties_1.NumberingFormat.HindiNumbers,
    list_level_properties_1.NumberingFormat.HindiDescriptive,
    list_level_properties_1.NumberingFormat.ThaiLetters,
    list_level_properties_1.NumberingFormat.ThaiNumbers,
    list_level_properties_1.NumberingFormat.ThaiDescriptive,
    list_level_properties_1.NumberingFormat.VietnameseDescriptive,
    list_level_properties_1.NumberingFormat.NumberInDash,
    list_level_properties_1.NumberingFormat.RussianLower,
    list_level_properties_1.NumberingFormat.RussianUpper,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
    list_level_properties_1.NumberingFormat.None,
];
